import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import { ChartBar, ArrowRight } from "@phosphor-icons/react";
import { useWorkingPanel } from "../../state/useWorkingPanel";

// Compact clickable card the agent's own reply renders inline (via a
// ```chart:ref fence — see ChatMessage.jsx) to reference a chart it just
// created. Lives in message `content`, not a separate message field, so it
// survives SET_MESSAGES / a page reload (see DataMappingContext.jsx —
// SET_MESSAGES keeps only {role, content}, and GET /messages only ever
// returns those two fields; nothing else attached to a message can persist).
export function ChartRefCard({ chartId }) {
  const { charts, chartCreated } = useWorkingPanel();
  const chart = charts.find((c) => c.id === chartId);

  if (!chart) {
    return (
      <Text fontSize="12px" color="gray.400" my={1}>
        Chart no longer available.
      </Text>
    );
  }

  return (
    <Flex
      as="button"
      type="button"
      onClick={chartCreated}
      align="center"
      gap={2}
      px={3}
      py={2}
      my={1}
      borderRadius="md"
      border="1px solid"
      borderColor="gray.200"
      bg="gray.50"
      w="100%"
      textAlign="left"
      transition="all 0.15s"
      _hover={{ borderColor: "lime", bg: "lightLime" }}
    >
      <ChartBar size={16} weight="fill" color="#85C22A" />
      <Text fontSize="13px" fontWeight="600" color="gray.700" flex="1" noOfLines={1}>
        {chart.title}
      </Text>
      <Text fontSize="12px" color="gray.500" whiteSpace="nowrap">
        View on Charts board
      </Text>
      <ArrowRight size={12} weight="bold" color="#718096" />
    </Flex>
  );
}
